import { render, staticRenderFns } from "./sheader.vue?vue&type=template&id=ccae5b10&scoped=true&"
import script from "./sheader.vue?vue&type=script&lang=js&"
export * from "./sheader.vue?vue&type=script&lang=js&"
import style0 from "./sheader.vue?vue&type=style&index=0&id=ccae5b10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccae5b10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ALink: require('/app/components/aLink.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
